// The files panel of the form that adds a counterparty (TX-US-0037). There is no counterparty
// to attach to until the form is saved, so a dropped file waits here; the form uploads the queue
// once the save has given it an identifier. The policy is the profile's (TX-US-0033).

import DropZone from '../../ui/DropZone.jsx';
import { ACCEPT, FORMATS_HINT } from './files.js';
import PendingFile from './PendingFile.jsx';

export default function StagedFiles({ uploads, disabled }) {
  return (
    <fieldset className="attachments">
      <legend>Files</legend>
      <DropZone accept={ACCEPT} onFiles={uploads.add} disabled={disabled} hint={FORMATS_HINT}>
        Drop files here, or choose them
      </DropZone>
      {uploads.items.length > 0 && (
        <ul className="attachment-list" aria-label="Files to attach">
          {uploads.items.map((item) => (
            <PendingFile key={item.key} item={item} waiting="Attached on save"
                         onRemove={disabled ? null : uploads.drop} />
          ))}
        </ul>
      )}
    </fieldset>
  );
}
